var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: {
        bus: _vm.busModal,
        centerScreen: "",
        centerAndDecreasesPadding: "",
        maxWidth: "960px",
        backgroundColor: "var(--dark)",
        withoutCloseButton: "",
        paddingOverride: "0",
        titleRowPaddingOverride: "0"
      }
    },
    [
      _c(
        "div",
        { staticClass: "release-announcement position-relative" },
        [
          _c(
            "v-btn",
            {
              staticClass: "release-announcement__close",
              attrs: { icon: "", small: "", "aria-label": "Fechar" },
              on: { click: _vm.close }
            },
            [
              _c("icon-svg", {
                attrs: { name: "close-circle", size: 24, color: "secondary" }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "release-announcement__body" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "release-announcement__content d-flex flex-column pa-6"
                },
                [
                  _vm.release.badge
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "az-ds-label release-announcement__badge mb-2"
                        },
                        [_vm._v(" " + _vm._s(_vm.release.badge) + " ")]
                      )
                    : _vm._e(),
                  _c(
                    "h2",
                    {
                      staticClass:
                        "az-title-secondary release-announcement__title mb-2"
                    },
                    [_vm._v(" " + _vm._s(_vm.release.title) + " ")]
                  ),
                  _vm.release.subtitle
                    ? _c(
                        "p",
                        {
                          staticClass:
                            "az-ds-body release-announcement__subtitle mb-4"
                        },
                        [_vm._v(" " + _vm._s(_vm.release.subtitle) + " ")]
                      )
                    : _vm._e(),
                  _c(
                    "transition",
                    {
                      attrs: {
                        name: "release-announcement-fade",
                        mode: "out-in"
                      }
                    },
                    [
                      _vm.currentCards.length
                        ? _c(
                            "div",
                            {
                              key: "cards-" + _vm.currentSlide,
                              staticClass:
                                "release-announcement__cards d-flex flex-column az-gap-small"
                            },
                            _vm._l(_vm.currentCards, function(card, index) {
                              return _c(
                                "div",
                                {
                                  key: "card-" + _vm.currentSlide + "-" + index,
                                  staticClass:
                                    "release-announcement__feature d-flex align-items-start az-gap-small pa-3"
                                },
                                [
                                  card.icon
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "release-announcement__feature-icon d-flex align-center justify-center flex-shrink-0"
                                        },
                                        [
                                          _c("icon-svg", {
                                            attrs: {
                                              name: card.icon,
                                              size: 18,
                                              color: "primary"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c("div", { staticClass: "flex-grow-1" }, [
                                    _c(
                                      "h3",
                                      {
                                        staticClass:
                                          "az-ds-card-title release-announcement__feature-title mb-1"
                                      },
                                      [_vm._v(" " + _vm._s(card.title) + " ")]
                                    ),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "az-ds-body release-announcement__feature-description mb-0"
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(card.description) + " "
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              ),
              _c(
                "transition",
                {
                  attrs: { name: "release-announcement-fade", mode: "out-in" }
                },
                [
                  _vm.currentImage
                    ? _c(
                        "div",
                        {
                          key: "media-" + _vm.currentSlide,
                          staticClass: "release-announcement__media"
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: _vm.currentImage,
                              alt: _vm.release.title
                            }
                          })
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass:
                "release-announcement__actions d-flex align-center justify-space-between px-6 py-4"
            },
            [
              _c(
                "div",
                { staticClass: "release-announcement__dots" },
                [
                  _vm.hasMultipleSlides
                    ? _vm._l(_vm.slides, function(slide, index) {
                        return _c("button", {
                          key: "dot-" + index,
                          staticClass: "release-announcement__dot",
                          class: {
                            "release-announcement__dot--active":
                              index === _vm.currentSlide
                          },
                          attrs: {
                            type: "button",
                            "aria-label": "Ir para o slide " + (index + 1)
                          },
                          on: {
                            click: function($event) {
                              return _vm.goToSlide(index)
                            }
                          }
                        })
                      })
                    : _vm._e()
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "d-flex align-items-center az-gap-small" },
                [
                  _c(
                    "BaseButton",
                    {
                      staticClass: "release-announcement__remind-later",
                      attrs: { underlined: "", minWidth: "auto" },
                      on: { click: _vm.remindLater }
                    },
                    [_vm._v(" Ver mais tarde ")]
                  ),
                  _c(
                    "BaseButton",
                    {
                      attrs: { primary: "", outline: "" },
                      on: { click: _vm.close }
                    },
                    [_vm._v(" Não mostrar novamente ")]
                  ),
                  _c(
                    "BaseButton",
                    { attrs: { primary: "" }, on: { click: _vm.next } },
                    [_vm._v(" " + _vm._s(_vm.actionLabel) + " ")]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }